import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Icon24 from 'builder/components/Icon'

export const Container = styled.div`
  position: sticky;
  top: 0;
  margin: 0 10px;
  margin: ${Spacing.L};
  ${Media.Tablet`
    margin: ${Spacing.S};
  `}

  ${Media.Phone`
    margin: ${Spacing.XS};
  `}
`

export const HeaderContainer = styled.div`
  display: flex;
  margin-top: 32px;
`
export const Header = styled.div`
  margin-left: 16px;
  width: 100%;
`

export const Company = styled.div`
  color: ${Colors.Neutral50};
  margin-bottom: 8px;
`

export const Position = styled.h1`
  ${Typography.S}
  ${FontWeights.DemiBold}
  margin-bottom: 8px;
`

export const Metas = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${Spacing.S};
  color: ${Colors.Neutral50};
  align-items: center;

  > :not(:last-child) {
    margin-right: 16px;
  }

  svg {
    color: ${Colors.Neutral50};
    fill: currentColor;
    margin-right: 4.1px;
  }
`

export const MetasAutoApply = styled.div`
  display: flex;
  flex-wrap: wrap;
  color: ${Colors.Neutral50};
  margin-top: ${Spacing.S};
  align-items: center;

  > :not(:last-child) {
    margin-right: 12px;
  }

  svg {
    margin-right: 4.2px;
  }
`

export const Separator = styled.div`
  margin: 32px 0px;
  height: 1px;
  background-color: ${Colors.Neutral20};
`

export const ApplyButtonIcon = styled(Icon24.ExternalLink)`
  flex: 1;
`

export const AccordionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${Spacing.XL};
  margin-bottom: ${Spacing.L};
  gap: ${Spacing.S};
`

export const Title = styled.div`
  ${Typography.Subhead}
  ${FontWeights.DemiBold}
  color: ${Colors.Neutral90};
`

export const AccordionTitleButton = styled(Link)`
  cursor: pointer;
  ${Typography.Body}
  ${FontWeights.Regular}
  color: ${Colors.Blue50};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ActionButtonBottomWrapper = styled.div`
  position: sticky;
  bottom: 0px;
  margin-bottom: 10px;
  display: block;
  ${Media.AboveTablet`
  display: none;
  `}
`

export const HeartIconButtonContainer = styled.div`
  position: absolute;
  right: 0;
`

export const SpacingContainer = styled.div`
  margin-top: ${Spacing.L};
  margin-bottom: ${Spacing.L};
`
